import './loadingPage.scss';

import React from 'react';

import { Loader } from '../../components/Loader';
import { Logo } from '../../components/Logo/Logo';

const LoadingPage = () => (
    <div className="pst-loading-page">
        <div className="content-container">
            <Logo large className="lp-logo" />
            <Loader />
        </div>
    </div>
);

LoadingPage.propTypes = {};

export { LoadingPage };
